import { ApiService } from '../../../../../services/api_service';
import formStyle from '../../../../../core/forms/style/WForm.less';
import { getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert } from '../../../functions/getCO2Scope3Structure';
import { IDs } from '../../../../../helpers/IDs';
import { lazyInject } from '../../../../../services/inversify';
import * as React from 'react';
import { WFormFieldSelect } from '../../../../../core/forms/WFormFramework';
import { WHelpIcon } from '../../../../../core/elements/WHelpIcon';

interface GhgKategorieAuswahlProps extends React.ClassAttributes<any> {
    data: any;
    hideLabels?: boolean;
    item: any;
    layout?: string;
    onValueChange(value: string): void;
    posFieldsHelpBeginning?: boolean;
    showFieldsHelp?: boolean;
    showMode?: boolean;
}

interface GhgKategorieAuswahlState {
    options: any[];
    value: string;
}

export class GhgKategorieAuswahl extends React.Component<GhgKategorieAuswahlProps, GhgKategorieAuswahlState> {

    constructor(props: any) {
        super(props);
        this.state = {
            options: null,
            value: (this.props.item || {}).ghg_kategorie
        };
        this.onValueChange = this.onValueChange.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private customStyle: React.CSSProperties;

    componentDidMount(): void {
        this.init();
    }

    init(): void {
        const bereichKey: string = this.apiService.getBereichKey();
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        const options: any[] = [
            ...getCO2Scope3StructureVorgelagert(bereichKey, modul),
            ...getCO2Scope3StructureNachgelagert(bereichKey, modul)
        ];
        this.customStyle = this.props.layout === 'sidebysideComplexGreen' ? { height: 46 } : {};
        options.forEach((item: any, index: number) => item.index = index);
        this.setState({ options });
    }

    onValueChange(name: string, value: string): void {
        this.setState({ value }, () => typeof this.props.onValueChange === 'function' && this.props.onValueChange(value));
    }

    render(): JSX.Element {
        if (!this.state.options) {
            return null;
        }

        return (
            <WFormFieldSelect
                key={`${IDs.ENT_CO2_SCOPE3_EMITTENTEN}_kategorie`}
                label={!this.props.hideLabels && this.renderLabel()}
                name='name'
                value={this.state.value}
                showMode={this.props.showMode}
                bundle_value='key'
                valueDefaultOption='GHG&#8209;Kategorie&nbsp;unbekannt'
                customStyle={this.customStyle}
                onValueChange={this.onValueChange}
                options={this.state.options}
                layout={this.props.layout}
            />
        );
    }

    renderFieldsHelp(): JSX.Element {
        // const backgroundColor: string = this.props.layout === 'sidebysideComplexGreen' ? '#00b050' : '#b9cde5';
        const helpKey: string = `${IDs.MOD_ETOOL}_${IDs.ENT_CO2_SCOPE3_EMITTENTEN}_ghg_kategorie`;

        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{
                    marginRight: this.props.posFieldsHelpBeginning ? 10 : 0, marginLeft: this.props.posFieldsHelpBeginning ? 0 : 10
                }}
                styleProps={{ margin: 0 }}
                label='Info "GHG-Kategorie"'
                helpKey={helpKey}
                type='theme_info'
                style='theme_small'
                editBar
                useTheme
            />
        );
    }

    renderLabel(): JSX.Element {
        return (
            <div className={formStyle.label}>
                {(this.props.showFieldsHelp && this.props.posFieldsHelpBeginning) && this.renderFieldsHelp()}
                <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
                    GHG-Kategorie
                </div>
                {(this.props.showFieldsHelp && !this.props.posFieldsHelpBeginning) && this.renderFieldsHelp()}
            </div>
        );
    }
}
